import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import api, { fileUrl } from "../lib/api";

export default function ImageUploader({ value, onChange, testid }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();
  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("تم رفع الصورة");
    } catch { toast.error("فشل رفع الصورة"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="flex items-center gap-3">
      {value ? (
        <img src={fileUrl(value)} alt="preview" className="w-16 h-16 rounded-lg object-cover border border-[#F0E8DB]/30" />
      ) : (
        <div className="w-16 h-16 rounded-lg bg-[#241615] border border-[#F0E8DB]/20 flex items-center justify-center text-[#BFB3A0]"><Upload size={20} /></div>
      )}
      <input ref={ref} type="file" accept="image/*" onChange={upload} className="hidden" data-testid={testid} id={testid} />
      <label htmlFor={testid} className="btn-ghost rounded-full px-4 py-2 text-sm cursor-pointer">
        {busy ? "..." : value ? "تغيير الصورة" : "رفع صورة"}
      </label>
      {value && <button type="button" onClick={() => onChange("")} className="text-[#BFB3A0] hover:text-[#F0E8DB] text-sm">إزالة</button>}
    </div>
  );
}

